import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { ROUTE_PATH } from "../../../../../constants/routePath";

const StyledSection = styled.section`
  //background: linear-gradient(to right, #2e2e2e, #ffe955);
  //background: linear-gradient(135deg, #2e2e2e, #ffe955);
  background: linear-gradient(-90deg, #2e2e2e 1%, #000 80%);
  padding: 128px 1rem;
  text-align: center;
  color: #ffffff;
`;

const Title = styled.h2`
  font-size: 3.125rem;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 26px;
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const StyledButton = styled(Button)`
  background-color: #ffe955;
  border-color: #ffe955;
  color: #000;
  font-size: 1.1rem;
  font-weight: 700;
  height: 48px;
  border-radius: 25px;
  padding: 0.5rem 2rem;

  &:hover, &:focus {
    background-color: #000!important;
    border-color: #000!important;
    color: #FFF!important;
  }
`;

const TrialText = styled.p`
  font-size: 0.9rem;
  margin-top: 1rem;
`;

const handleSignUp = () => {
  window.location.href = `https://admin.sparkle.store${ROUTE_PATH.REGISTER}`;
};

const SparkleCTASection = () => (
  <StyledSection>
    <Title>Get started with Sparkle</Title>
    <Subtitle>
      Launch your online store with Sparkle and access all the tools and services you need to start, manage, and expand your business.
    </Subtitle>
      <StyledButton onClick={handleSignUp} type="primary" size="large">
        Start Free Store
      </StyledButton>
    <TrialText>Try Sparkle free, no credit card required</TrialText>
  </StyledSection>
);

export default SparkleCTASection;